
<!-- <button class="btn btn-outline-secondary btn-sm px-2 d-flex align-items-center justify-content-center"><app-svg-icon *ngIf="buttonLable" [src]="imgUrl"></app-svg-icon><span *ngIf="buttonLable" class="m-t-2 m-l-5">{{buttonLable}}</span></button> -->

<button
*ngIf="!button_2"
  class="btn btn-lg px-2 py-0 d-flex align-items-center justify-content-center" 
  [ngClass]="buttonClass"
  [disabled]="inputReadonly"
>
  <app-svg-icon [src]="imgUrl" [disabled]="inputReadonly" (click)="onIconClick($event)"></app-svg-icon
  ><span class="my-auto" *ngIf="buttonLable" [disabled]="inputReadonly" [ngClass]="{ 'm-l-5': imgUrl}" >{{ buttonLable }}</span>
</button>

<button *ngIf="button_2" 
    [class]="buttonClass"
    [type]="buttonType"
    [ngClass]="ngClass"
    [disabled]="inputReadonly"
    
    [readonly]="inputReadonly">
    <span  [class]="spanClass"> {{buttonLable}}</span>
    <app-svg-icon [src]="buttonImageUrl" (click)="onIconClick($event)"></app-svg-icon>
</button>